import React from 'react'
import RaisedButton from 'material-ui/RaisedButton'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import images from '../../config/images'
import { LinkContainer, NavigationContainer } from './styles'
import './index.css'
import { Helmet } from 'react-helmet'

const isSignup = (pathname) => {
  const substr = 'signup'
  return (pathname) ? (pathname.indexOf(substr) !== -1) : false
}

const Navigation = (props) => (
  <NavigationContainer className='flex justify-between'>
    <LinkContainer>
    </LinkContainer>
    <Helmet title={'FreshVoice Webinar'}/>
    <div className='flex justify-between items-center'>
      <img src={images.webinar_logo} alt='logo'/>
      <Link style={{color: 'white', opacity: 0.5, textDecoration: 'none'}} to={'/'}>
        <div onClick={() => {
          let locale = localStorage.getItem('locale')
          if (locale == 'ja') {
            localStorage.setItem('locale', 'en')
          } else {
            localStorage.setItem('locale', 'ja')
          }
          window.location.reload()
        }} style={{padding: '20px', whiteSpace: 'nowrap'}}>{'日本語/English'}</div>
      </Link>
    </div>

    {(!isSignup(props.path)) ? (
      <LinkContainer>
        <Link to={'/signup'}>
          <div className='signup'>
            <RaisedButton
              backgroundColor='#FCCE42'
              label={<FormattedMessage id='loggedOutNavigation.register'/>}
              labelStyle={{fontWeight: 'normal'}}
              labelColor='#8B7124'
            />
          </div>
        </Link>
      </LinkContainer>
    ) : <div className='w-10'/>}
  </NavigationContainer>
)

export default Navigation



// WEBPACK FOOTER //
// ./src/layouts/LoggedOut/Navigation.js